import * as React from 'react';
import * as Redux from 'react-redux';

import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Tab from '@mui/material/Tab';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Tabs from '@mui/material/Tabs';
import { useNotification } from '../../../../helpers/Notification';
import { LoadingWidget } from '../../../../widgets';
import {
  CustomTabPanel,
  a11yProps,
} from '../../../control_estudios/materias/components/AsignarCarreras';
import SelectFieldMateriasComponent from '../../../control_estudios/materias/components/SelectFieldMaterias';
import BotonComponent from '../../../dashboard/components/BotonNuevo';
import {
  allTemasAcademicosAction,
  asignarTemaMateriasAction,
  deleteTemaMateriasAction,
  setActivoTemasAcademicosAction,
} from '../TemasAcademicosAction';
import FormTemasAcademicos from './FormTemasAcademicos';

const AsignarMaterias = ({ setOpenModalForm }) => {
  const dispatch = Redux.useDispatch();
  const { notify } = useNotification();

  const loginStore = Redux.useSelector((state) => state.login);
  const docentesStore = Redux.useSelector((state) => state.docentes);
  const temasAcademicosStore = Redux.useSelector(
    (state) => state.temasAcademicos,
  );

  const activo = temasAcademicosStore.activo;

  const [value, setValue] = React.useState(0);
  const [idMateria, setIdMateria] = React.useState(null);
  const [loadingSave, setLoadingSave] = React.useState(false);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <Box sx={{ width: '100%' }}>
      <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
        <Tabs value={value} onChange={handleChange} aria-label="Materia">
          <Tab label="Informacion" {...a11yProps(0)} />
          <Tab label="Materias" {...a11yProps(1)} />
        </Tabs>
      </Box>
      <CustomTabPanel value={value} index={0}>
        <FormTemasAcademicos
          setOpenModalForm={(value) => setOpenModalForm(value)}
        />
      </CustomTabPanel>
      <CustomTabPanel value={value} index={1}>
        <Grid container spacing={1}>
          <LoadingWidget isLoading={loadingSave} />
          <Grid item xs={8} md={8}>
            <SelectFieldMateriasComponent
              value={idMateria}
              isAll={false}
              data={
                loginStore.isAdminTeacher ? null : docentesStore.activo.materias
              }
              onChange={(idMateria) => setIdMateria(idMateria)}
            />
          </Grid>
          <Grid item xs={4} md={4}>
            <BotonComponent
              disabled={idMateria === null || idMateria === 0}
              click={async () => {
                setLoadingSave(true);
                await asignarTemaMateriasAction(
                  { dispatch, notify },
                  {
                    idTema: temasAcademicosStore.activo.id,
                    idMateria,
                  },
                );
                setIdMateria(null);
                setLoadingSave(false);
                allTemasAcademicosAction(dispatch, temasAcademicosStore.params);
                setActivoTemasAcademicosAction(dispatch, null);
                setOpenModalForm(false);
              }}
              text="AGREGAR"
              blue
              addIcon
            />
          </Grid>
          <Grid item md={12}>
            <Box sx={{ minWidth: '800px' }}>
              <TableContainer>
                <Table
                  sx={{ width: '100%' }}
                  size="small"
                  aria-label="a dense table"
                >
                  <TableHead>
                    <TableRow>
                      <TableCell width="40%">Tema</TableCell>
                      <TableCell></TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {activo.materias.map((el, index) => (
                      <TableRow
                        key={index}
                        sx={{
                          '&:last-child td, &:last-child th': { border: 0 },
                        }}
                      >
                        <TableCell width="60%" component="th">
                          {el.materia.nombre}
                        </TableCell>

                        <TableCell>
                          <BotonComponent
                            click={async () => {
                              setLoadingSave(true);
                              await deleteTemaMateriasAction(
                                { dispatch, notify },
                                temasAcademicosStore.activo.id,
                                el.id,
                              );
                              setIdMateria(null);
                              setLoadingSave(false);
                              allTemasAcademicosAction(
                                dispatch,
                                temasAcademicosStore.params,
                              );
                              setActivoTemasAcademicosAction(dispatch, null);
                              setOpenModalForm(false);
                            }}
                            text="ELIMINAR"
                            red
                          />
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </Box>
          </Grid>
        </Grid>
      </CustomTabPanel>
    </Box>
  );
};

export default AsignarMaterias;
